import Header from "./components/Layout/Header";
import Meals from "./components/Meals/Meals";
import { useState, useEffect } from "react";
import CartProvider from "./store/CartProvider";
import Cart from "./components/Cart/Cart";
import Footer from "./components/Layout/Footer";
import Checkout from "./components/UI/Checkout";
import "./App.css";
function App() {
  const [cartIsShown, setCartIsShown] = useState(false); //because main page ki hi state change hogi when we will click on cart button

  useEffect(() => {
    // Check if the user is already logged in and set the user details in local storage
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser) {
      setUser(loggedInUser);
    }
  }, []);

  const [user, setUser] = useState(null);

  const shownCartHandeler = () => {
    setCartIsShown(true);
  };

  const hideCartShowHandeler = () => {
    setCartIsShown(false);
  };
  return (
    <CartProvider>
      {cartIsShown && <Cart onHideCart={hideCartShowHandeler} />}
      {/* if this do this */}
      <Header onShowCart={shownCartHandeler} />

      {/* lifting data up */}

      <main>
        <Meals />
      </main>
      <Footer />
    </CartProvider>
  );
}

export default App;

// import classes from "./CheckoutModel.module.css";
// import ReactDOM from "react-dom";
// import React, { Fragment, useState } from "react";

// const Backdrop = (props) => {
//   return <div className={classes.backdrop} onClick={props.onHideCart}></div>;
// };

// const ModalOverlay = (props) => {
//   return (
//     <div className={classes.modal}>
//       <div className={classes.content}>{props.children}</div>
//     </div>
//   );
// };

// const portalElement = document.getElementById("CheckoutOverlays");

// const CheckoutModal = (props) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     address: "",
//     paymentMethod: "creditCard",
//   });

//   const inputChangeHandler = (event) => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [event.target.id]: event.target.value,
//     }));
//   };

//   const submitHandler = (event) => {
//     event.preventDefault();
//     // Perform form submission logic (e.g., validation, payment integration, order placement)
//     // You can access the form data using the 'formData' state object
//     // Reset the form data and show a success message upon successful submission
//     setFormData({
//       name: "",
//       email: "",
//       address: "",
//       paymentMethod: "creditCard",
//     });
//     props.onHideCart();
//     props.onOrderPlaced();
//   };

//   return (
//     <Fragment>
//       {ReactDOM.createPortal(
//         <Backdrop onHideCart={props.onHideCart} />,
//         portalElement
//       )}
//       {ReactDOM.createPortal(
//         <ModalOverlay>
//           <div>
//             <form onSubmit={submitHandler}>
//               <div className={classes.form}>
//                 <label htmlFor="name">Name:</label>
//                 <input
//                   id="name"
//                   type="text"
//                   value={formData.name}
//                   onChange={inputChangeHandler}
//                   required
//                 />
//               </div>
//               <div className={classes.form}>
//                 <label htmlFor="email">Email:</label>
//                 <input
//                   id="email"
//                   type="email"
//                   value={formData.email}
//                   onChange={inputChangeHandler}
//                   required
//                 />
//               </div>
//               <div className={classes.form}>
//                 <label htmlFor="address">Address:</label>
//                 <input
//                   id="address"
//                   type="text"
//                   value={formData.address}
//                   onChange={inputChangeHandler}
//                   required
//                 />
//               </div>
//               <div className={classes.form}>
//                 <label htmlFor="paymentMethod">Payment Method:</label>
//                 <select
//                   id="paymentMethod"
//                   value={formData.paymentMethod}
//                   onChange={inputChangeHandler}
//                 >
//                   <option value="creditCard">Credit Card</option>
//                   <option value="paypal">PayPal</option>
//                 </select>
//               </div>
//               <div className={classes.actions}>
//                 <button
//                   className={classes["button--alt"]}
//                   onClick={props.onHideCart}
//                 >
//                   Close
//                 </button>

//                 <button type="submit" className={classes.button}>
//                   Order
//                 </button>
//               </div>
//             </form>
//           </div>
//         </ModalOverlay>,
//         portalElement
//       )}
//     </Fragment>
//   );
// };

// export default CheckoutModal;
